import { FormikValues } from 'formik';
import * as Yup from 'yup';


export const initialValues: FormikValues = {
  cancelReason: '',
  cancellationDate: '',
  cancelComment: '',
};

export const validationSchema = Yup.object().shape({
  cancelReason: Yup
    .string()
    .required('You must enter a reason'),

  cancellationDate: Yup
    .date()
    .typeError('You must enter a valid date')
    .required('You must enter a date'),

  cancelComment: Yup
    .string()
    .max(100, 'Comment must be no more than 100 characters')
    .required('You must enter a comment'),
});
